module.exports = __webpack_public_path__ + "img/img_book_kb.d059b193.jpg";